const settings = {
  APP_NAME: 'Global Opps',
  API_URL: 'https://api.airtable.com/v0/',
  AIRTABLE_ID: 'app8cNGmDgEAAsjfB',
  AIRTABLE_ID2: 'app8cNGmDgEAAsjfB',
  // READ ONLY AIR TABLE API KEY
  API_KEY: 'keyJKuRwLEgXlUNDh',
  ACCESS_TOKEN:
    'pat2g0Ud94UyEQgq9.988caf18dd6599da1a39f7cc676cf5a8a645bc8b6688a5c312b604f2f424cfad',
};

export default settings;
